export default __webpack_public_path__ + "static/media/audio_18_maquina_de_escribir.4f15d426.mp3";